<template>
  <b-container fluid class="booking-sum-up">
    <b-row v-if="!isLoaded" class="loader-section">
      <frontoffice-loader/>
    </b-row>

    <div v-else>
      <div v-if="errors.length">
        <div v-for="error in errors">
          {{ $t(`error.${error}`) }}
        </div>
      </div>

      <div v-else>
        <div class="header">
          <page-title>
            <b-row>
              <b-col cols="6" md="7">{{ $t('booking.my_booking') }}</b-col>

              <b-col cols="6" md="5" class="back-link" v-if="!isUnlogged && !stateFormation">
                <back-button name="bookings" class="orange-white btn">
                  {{ $t("_my_bookings.title") }}
                </back-button>
              </b-col>
            </b-row>
          </page-title>
        </div>

        <booking-show v-if="isLoaded" v-bind="$data" :is-manager="isManager"
                      @update="initBooking($event)" :is-unlogged="isUnlogged"
        />
      </div>
    </div>
  </b-container>
</template>

<script>
import backButton from '@/components/frontoffice/button/back'
import frontofficeFrame from '@/components/frontoffice/frame'
import frontofficeLoader from '@/components/frontoffice/loader'
import BookingShow from '@/components/frontoffice/Booking/show'
import CommonApi from '@/api/commonApi'
import pageTitle from '@/components/backoffice/pageTitle'

export default {
  components: {
    frontofficeFrame,
    frontofficeLoader,
    BookingShow,
    pageTitle,
    backButton
  },

  props: {
    isUnlogged: {
      type: Boolean,
      default: false
    },
    isValidation: {
      type: Boolean,
      default: false
    },
    validationId: String
  },

  data () {
    return {
      commonApi: new CommonApi(),
      booking: null,
      isLoaded: false,
      isManager: false,
      actions: [],
      errors: [],
      stateFormation: false
    }
  },

  created () {
    this.stateFormation = this.$store.getters['research/context'] === 'formation'
    this.initBooking()
  },

  methods: {
    initBooking (bookingId = null) {
      if (this.isValidation) {
        this.commonApi.searchBookingValidation(
          this.validationId,
          bookingId,
          !bookingId
        ).then(response => {
          this.isLoaded = true

          if (response.data.errors.length){
            this.errors = [404]
          } else {
            this.booking = response.data.data.booking
            this.isManager = response.data.data.isManager
            this.actions = response.data.data.actions || {}
            delete this.actions.show
          }
        })
      } else {
        this.commonApi.searchBooking(this.$route.params.id, false, true)
          .then(response => {
            if (response.data.success) {
              this.booking = response.data.data.booking
              this.isManager = response.data.data.isManager
              this.actions = response.data.data.actions
              delete this.actions.show
            } else {
              Object.entries(response.data.errors).forEach( error => {
                this.errors.push(this.$te(`error.${error[0]}`)
                  ? error[0]
                  : error[1]
                )
              })
            }

            this.isLoaded = true
          })
      }
    }
  }
}
</script>
